import styled from '@emotion/styled';
import React,{useState} from 'react'
import { useSettingModal } from '../../../../hooks/Context';
import { ModalContainer,IconContainer,UIcon,SubmitContainer,StyleButton } from './CreateAdminUser';
import apiCall from '../../../../utils/apiCall';


const StyledForm = styled.form`
    background-color  :#fff ;
    display:flex;
    flex-direction: column;
    gap:20px;
    padding:20px 30px; 
     & > *{
        width:50%;
     }
`;


const StyledLabel = styled.label`
    display: flex;
    flex-direction: column;
    gap:10px;
`

const StyledInput = styled.input`
    padding:15px;
    border:1px solid #E1E1E1;
    outline:none;
    border-radius: 5px;
`



const CreateZones = () => {
    const {setShowModal} = useSettingModal()
    const [ZonesName,setZonesName] = useState<string>('');
    const [ZonesId,setZonesId] = useState<string>('');
    
    const handleSubmit =(e:any)=>{
        e.preventDefault();
        if(ZonesName && ZonesId){
            const apiData = {
                Id:Math.floor(Math.random() * 1000)+1,
                ZonesName:ZonesName,
                ZonesId:ZonesId
            }
           
            apiCall().post(`/api/Zone/Create`, apiData)
            .then(data =>{
               
            })
            .catch(err =>{
             
            })
        }
    }
  return (
    <ModalContainer>
         <div>
            <div>
            <div>
                <IconContainer><UIcon /></IconContainer>
                <span>Create Zones</span>
            </div>
            </div>
            <StyledForm onSubmit={handleSubmit}>
                {/* <StyledLabel>
                    <span>Name</span>
                    <StyledInput value={ZonesName}
                    onChange={(e)=>setZonesName(e.target.name)}
                     type="text" placeholder='Name' />
                </StyledLabel> */}
                <StyledLabel>
                    <span>Zone Name</span>
                    <StyledInput id={ZonesId}
                    onChange={(e)=>setZonesName(e.target.name)}
                     type="text" placeholder='Zone Name' />
                </StyledLabel>
                <SubmitContainer>
                    <span onClick={()=>setShowModal(false)}>Cancel</span>
                    <StyleButton>Submit</StyleButton>
                </SubmitContainer>
            </StyledForm>
        </div>
    </ModalContainer>
  )
}

export default CreateZones